import createAxiosInstance from './axiosConfig';
import { RegionalDTO } from '../shared/dto/regionalDTO';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/regionalController');

export default class RegionalService {
  axios: any;

  constructor() {
    this.axios = axiosInstance;
  }
  
  async listarTodasRegionaisPorRole() {
    return await this.axios.get(`/listarTodasRegionaisPorRole`);
  };

  async ativarInativarRegional(id: string) {
    return await this.axios.get(`/ativarInativarRegional?id=${id}`);
  };

  async listarRegionalPorId(id: string) {
    return await this.axios.get(`/listarRegionalPorId?id=${id}`);
  };

  async incluirAlterarRegional(dto: RegionalDTO) {
    return await this.axios.post(`/incluirAlterarRegional`, dto);
  };

  async listarTodasRegionaisAtivas() {
    return await this.axios.get(`/listarTodasRegionaisAtivas`);
  };

public async listarPorMatriz(idMatriz: string | number): Promise<any> {
    return this.axios.get(`/listarPorMatriz?idMatriz=${idMatriz}`);
  };

  async listarRegionais(page: number, size: number, filters: any) {
    const params = new URLSearchParams();
    
    params.append('page', String(page));
    params.append('size', String(size));

    for (const key in filters) {
      if (filters[key]) {
        params.append(key, filters[key]);
      }
    }
    return await this.axios.get(`/listar`, { params });
  };
}